import type { IconName } from './iconNames';

export const INCIDENT_OPERATION_ICONS = {
  incident: 'plus',
  chat: 'comments',
  videoChat: 'video',
  locate: 'crosshairs',
} as const satisfies Record<string, IconName>;
